export const notificationsEndpoints = {
    clear : 'api/Notification/ClearNotification'
  };